<template>
  <button
    :class="['clothing__option', { '--active': isActive(clothing) }]"
    @click="updateAvatarClothingType(clothing)"
    :disabled="isDisabled(clothing)"
  >
    <Image :source="clothing.icon" class="clothing__option-image" />
  </button>
</template>

<script>
import { Image } from '@/components/global'

export default {
  name: 'ClothingOption',
  components: { Image },
  props: {
    activeType: {
      type: String,
      required: true,
    },
    clothing: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isActive(clothing) {
      return clothing.id === this.$store.state.hunter.avatar[this.activeType]
    },
    isDisabled(clothing) {
      return clothing.level > this.$store.state.hunter.level
    },
    updateAvatarClothingType(clothing) {
      this.$store.dispatch('updateAvatarClothingType', { id: clothing.id, type: this.activeType })
    },
  },
}
</script>
